<template>
  <div class="wave-container">
    <WaveHeader :title="$t('Webportal.ActualWaveStatus')"
                :description="$t('Webportal.ActualWaveStatus.Description')"
                @detail-click="onDetailClick" />
    <WaveList :wave-data="waveData" />
  </div>
</template>

<script>
import WaveHeader from './WaveHeader.vue';
import WaveList from './WaveList.vue';

export default {
  name: 'WaveBoard',

  components: {
    WaveHeader,
    WaveList
  },

  props: {
    boardData:      { type: Object, required: true },
    boardSetup:     { type: Object, required: true },
    waveData:       { type: Object, required: true }
  },

  emits: ['detail-click'],

  methods: {
    onDetailClick() {
      this.$emit('detail-click');
    }
  }
}
</script>

<style lang="scss" scoped>
.wave-container {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  padding: 1.5rem;
  background-color: var(--bs-body-bg);
  border: 1px solid var(--bs-border-color);
  border-radius: 0.75rem;
  transition: all 0.15s ease-in-out;

  &:hover {
    border-color: var(--bs-border-color-translucent);
  }
}
</style>
